<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'SETTINGS.SETTINGS' | transloco">
    <sbnb-settings-subnav></sbnb-settings-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <div fxLayout="column" class="settings-header" data-intercom-target="sync-settings-header">
      <app-feature-flag-tabs>
        <sbnb-page-header navTabs>
          <div fxLayout fxLayoutAlign="space-apart center">
            <h2 class="nomargin">Sync</h2>
          </div>
        </sbnb-page-header>
        <h2 class="nomargin">Sync</h2>
      </app-feature-flag-tabs>
      <p class="night-lighter">
        When Sync is enabled for a property, we frequently check for any updates to your lead listings that happen
        outside of Hospitable.com and copy those updates to the other listings in the property. You can control what
        information gets synced below. Any changes you make on the
        {{ 'CORE.PRODUCT_NAME' | transloco }} Calendar are always pushed to all listings without delay.
      </p>

      <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
    </div>

    <ng-container *ngIf="syncSettings$ | async as syncSettings; else loading">
      <div
        *ngFor="let setting of syncSettings"
        class="setting-container"
        [attr.data-intercom-target]="setting.key"
        fxLayout="column">
        <div
          fxLayout
          fxLayoutAlign="start center"
          fxLayoutGap="8px"
          [class.is-disabled]="setting.disabled"
          class="setting">
          <mat-slide-toggle *ngIf="!setting.disabled" [(ngModel)]="setting.value">
            <strong>{{ setting.title }}</strong>
          </mat-slide-toggle>

          <div
            *ngIf="setting.disabled"
            fxLayout
            fxLayoutAlign="start center"
            fxLayoutGap="8px"
            class="strong disabled-title">
            <mat-slide-toggle
              [checked]="setting.value"
              (click)="$event.preventDefault(); $event.stopPropagation()"></mat-slide-toggle>

            <span>{{ setting.title }}</span>
          </div>

          <span *ngIf="setting.coming_soon" class="badge badge-grass">Coming soon</span>

          <a *ngIf="setting.help_article" target="_blank" [href]="setting.help_article" class="flex">
            <sbnb-icon icon="details" class="smoke-darker"></sbnb-icon>
          </a>
        </div>

        <small
          *ngIf="setting.refreshes && setting.refreshes !== ''"
          class="text__xsmall refreshes"
          [class.grass-darker]="setting.value === true"
          [class.night-lighter]="setting.value === false">
          {{ setting.refreshes }}
        </small>

        <span class="text__small night">{{ setting.label }}</span>
      </div>

      <div fxLayout fxLayoutAlign="space-between center" class="buttons">
        <sbnb-button
          [disabled]="saveStatus !== 0"
          [loading]="saveStatus !== 0"
          size="mini"
          label="Save changes"
          (clicked)="saveChanges(syncSettings)"></sbnb-button>
        <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
      </div>
    </ng-container>

    <!--loading-->
    <ng-template #loading>
      <mat-spinner [diameter]="30"></mat-spinner>
    </ng-template>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Settings'">
  <sbnb-settings-subnav></sbnb-settings-subnav>
</sbnb-mobile-sidebar>
